__turbopack_context__.v({
  "elevenTop": "wLN-ta_elevenTop",
  "fiveBottom": "wLN-ta_fiveBottom",
  "fiveTop": "wLN-ta_fiveTop",
  "heroBottomWave": "wLN-ta_heroBottomWave",
  "heroBottomWavePatient": "wLN-ta_heroBottomWavePatient",
  "nineBottom": "wLN-ta_nineBottom",
  "oneTop": "wLN-ta_oneTop",
  "oneTopWhiteSpace": "wLN-ta_oneTopWhiteSpace",
  "sevenBottom": "wLN-ta_sevenBottom",
  "sevenTop": "wLN-ta_sevenTop",
  "shapeFill": "wLN-ta_shapeFill",
  "topNine": "wLN-ta_topNine",
  "twelveBottom": "wLN-ta_twelveBottom",
  "twelveTop": "wLN-ta_twelveTop",
  "twoBottom": "wLN-ta_twoBottom",
  "twoTop": "wLN-ta_twoTop",
});
